// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CommissionerProvider } from './contexts/CommissionerContext';
import { InjuryProvider } from './contexts/InjuryContext';
import { PlayerNotesProvider } from './contexts/PlayerNotesContext';
import { initializeSeasonCache } from './utils/seasonUtils';
import AppRoutes from './components/AppRoutes';

function App() {
  // Initialize season cache on app startup
  useEffect(() => {
    initializeSeasonCache();
  }, []);

  return (
    <AuthProvider>
      <InjuryProvider>
        <PlayerNotesProvider>
          <CommissionerProvider>
            <Router>
              <AppRoutes />
            </Router>
          </CommissionerProvider>
        </PlayerNotesProvider>
      </InjuryProvider>
    </AuthProvider>
  );
}

export default App;